/**
 * Transforms data from ResolutionSearchArticlesQuery into a universal format of
 * ArticleSuggestion[]
 */
export function transformResolutionSearchArticles(articleSuggestions) {
    if (!articleSuggestions)
        return [];
    const suggestions = articleSuggestions.searchArticles.results.map(({ accessControl, id, slug, title, tags, category }) => {
        const articleData = {
            accessControl,
            category,
            id,
            slug,
            title,
            tags,
        };
        return articleData;
    });
    return suggestions;
}
/** Transforms suggestions data */
export function transformSuggestions(suggestionData) {
    if (!suggestionData)
        return [];
    const suggestions = suggestionData.suggestedArticles.results.map((result) => {
        const suggestion = Object.assign(Object.assign({}, result), { __typename: 'ArticleSearchResult' });
        return suggestion;
    });
    return suggestions;
}
